import type { ExtractKeysWithDotNotation } from "@tellescope/ui";
import { useTypedSearchParams } from "../../../hooks/use-typed-search-params";

export interface ChatCompositionPanelQueryParams {
  enduserId?: string;
  subject?: string;
}

const VALID_CHAT_COMPOSITION_PANEL_QUERY_PARAM_KEYS = [
  "enduserId",
  "subject",
] as const satisfies ExtractKeysWithDotNotation<ChatCompositionPanelQueryParams>[];

const CHAT_COMPOSITION_PANEL_ARRAY_KEYS =
  [] as const satisfies ExtractKeysWithDotNotation<ChatCompositionPanelQueryParams>[];

export const useChatCompositionPanelSearchParams = () => {
  return useTypedSearchParams<ChatCompositionPanelQueryParams>(
    VALID_CHAT_COMPOSITION_PANEL_QUERY_PARAM_KEYS,
    CHAT_COMPOSITION_PANEL_ARRAY_KEYS
  );
};
